import { useRecoilValue } from "recoil";
import useMixpanelMKT from "../../hooks/useMixpanelMKT";
import { userSimpleAtom } from "../../recoil/userSimpleAtom";
import LoginButtonTemplatePromotion from "./LoginButtonTemplatePromotion";
import useKakaoLoginPromotion from "../../hooks/useKakaoLoginPromotion";

export default function KakaoLoginButtonPromotion({
  render,
  onNotCoach,
}: {
  render?: (props: {
    onClick: (e?: any) => void;
    disabled?: boolean;
  }) => JSX.Element;
  onNotCoach?: () => void;
}) {
  const handleLogin = useKakaoLoginPromotion();
  const user = useRecoilValue(userSimpleAtom);

  const trackLoginButtonClick = useMixpanelMKT({
    eventName: "로그인 버튼 클릭",
    params: { method: "kakao" },
    version: "v4",
  });

  return (
    <LoginButtonTemplatePromotion
      loginType="kakao"
      action={() => {
        trackLoginButtonClick();
        handleLogin();
      }}
      isLoggedIn={!!user?.accessToken}
      widthPx={320}
    />
  );
}
